var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 7.85713C5.87861 7.85713 7.28571 6.45002 7.28571 4.71427C7.28571 2.97852 5.87861 1.57141 4.14286 1.57141C2.40711 1.57141 1 2.97852 1 4.71427C1 6.45002 2.40711 7.85713 4.14286 7.85713Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 7.85713C14.45 7.85713 15.8571 6.45002 15.8571 4.71427C15.8571 2.97852 14.45 1.57141 12.7143 1.57141C10.9785 1.57141 9.57141 2.97852 9.57141 4.71427C9.57141 6.45002 10.9785 7.85713 12.7143 7.85713Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 16.4285C5.87861 16.4285 7.28571 15.0215 7.28571 13.2857C7.28571 11.5499 5.87861 10.1428 4.14286 10.1428C2.40711 10.1428 1 11.5499 1 13.2857C1 15.0215 2.40711 16.4285 4.14286 16.4285Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 16.4285C14.45 16.4285 15.8571 15.0215 15.8571 13.2857C15.8571 11.5499 14.45 10.1428 12.7143 10.1428C10.9785 10.1428 9.57141 11.5499 9.57141 13.2857C9.57141 15.0215 10.9785 16.4285 12.7143 16.4285Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.321731c8e84a51b9c08d46db627539af.svg";
export { ForwardRef as ReactComponent };